import {
  Box,
  HStack,
  Stack,
  useColorModeValue,
  useRadio,
  UseRadioProps,
} from "@chakra-ui/react";
import { Heading12 } from "components/Heading";
import { Text12 } from "components/Text";
import { CSSProperties } from "react";

interface NewCaminoOptionProps {
  label: string;
  description: string;
  icon?: JSX.Element;
  width?: string;
  boxProps?: object;
  containerProps?: object;
  contentContainerProps?: object;
  hoverStyles?: CSSProperties;
  checkedStyles?: CSSProperties;
}

export default function NewCaminoOption(props: UseRadioProps & NewCaminoOptionProps) {
  const headingColor = useColorModeValue("cdsGrey.900", "cdsGrey.500");
  const subheadingColor = useColorModeValue("content.tertiary", "cdsGrey.500");
  const checkedBg = useColorModeValue("cdsIndigo.50", "cdsIndigo.100");
  const { getInputProps, getRadioProps } = useRadio(props);
  const {
    icon, label, description, width = "270px", containerProps = {}, boxProps = {}, contentContainerProps = {}, hoverStyles = {}, checkedStyles = {},
  } = props;
  const input = getInputProps();
  const radio = getRadioProps();

  return (
    <Box as="label" w="full" {...containerProps}>
      <input {...input} />
      <Box
        {...radio}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="5px"
        width={width}
        bg="bg.tertiary"
        _checked={{
          bg: checkedBg,
          borderColor: "cdsIndigo.800",
          borderWidth: "1px",
          ...checkedStyles,
        }}
        _hover={{
          borderColor: "cdsIndigo.400",
          bg: "cdsIndigo.100",
          ...hoverStyles,
        }}
        px={5}
        py={4}
        {...boxProps}
      >
        <HStack spacing={3} alignItems="center" {...contentContainerProps}>
          {icon}
          <Stack textAlign="left" gap="1">
            <Heading12 color={headingColor}>{label}</Heading12>
            <Text12 color={subheadingColor}>
              {description}
            </Text12>
          </Stack>
        </HStack>
      </Box>
    </Box>
  );
}
